import Phaser, { Physics, Scale, Scene } from "phaser";
import TitleScreen from "./sceanes/TitleScreen";
import Game from "./sceanes/Game";
import GameOverScreen from "./sceanes/GameOverScreen";

const config = {
  type: Phaser.AUTO,
  width: window.innerWidth,
  height: window.innerHeight,
  backgroundColor: "#11111b",

  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH
  },

  physics: {
    default: 'arcade',
    arcade: {
      gravity: { y: 0 },
      debug: false,
    },
  }
}

const game = new Phaser.Game(config)

game.scene.add('title-screen', TitleScreen);
game.scene.start('title-screen')
game.scene.add('game', Game);
game.scene.add('game-over', GameOverScreen)
// game.scene.start('game');
